import { getSignInAuth } from '@/config/auth';
import throwClientError from './helpers/throwClientError';
export default async function sendPasswordResetCode(email) {
    try {
        await getSignInAuth().forgotPassword(email.toLowerCase());
        return {};
    }
    catch (error) {
        return throwClientError(error);
    }
}
